import PropTypes from 'prop-types'

export function ToggleField({
  name,
  label,
  title,
  value,
  onChange,
  disabled,
  id,
  style,
  labelOnRight,
  ...props
}) {
  return (
    <div
      className={`field field-toggle ${disabled ? 'field--disabled' : ''}`}
      title={title}
      style={style}
    >
      {label ? !labelOnRight ? <span>{label}</span> : null : null}
      <div className="checkbox-wrapper">
        <input
          name={name}
          id={id || name}
          type="checkbox"
          checked={value}
          onChange={onChange}
          disabled={disabled}
          {...props}
        />
        <label htmlFor={id || name} />
      </div>
      {label ? labelOnRight ? <span>{label}</span> : null : null}
    </div>
  )
}

ToggleField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  id: PropTypes.string,
  style: PropTypes.object,
  labelOnRight: PropTypes.bool,
}

ToggleField.defaultProps = {
  value: false,
}

export default ToggleField
